export default __webpack_public_path__ + "static/media/template-hd2.c194d512.png";